import HomePage from './components/HomePage';
import useHomeController from './controllers/useHomeController';
import '../VerifyMember/input.css';
import 'flatpickr/dist/flatpickr.min.css';

const Home = () => {
    const controller = useHomeController();

    return <HomePage {...controller} />;
};

export default Home;
